import { connect } from 'react-redux';
import * as actions from 'embed/actions';
import reducers from 'embed/reducers';
import Popup from 'embed/components/Popup'

export default connect(reducers, actions)(Popup);
